module.exports = __webpack_public_path__ + "pc-top-assets/img/logo-second.b2b1d19e.png";